(ns ballot-scout-v2-frontend.layout.header.views
  (:require
   [ballot-scout-v2-frontend.components.icon :refer [icon] :as icon]
   [ballot-scout-v2-frontend.components.link :refer [href link]]
   [ballot-scout-v2-frontend.events :as events]
   [ballot-scout-v2-frontend.layout.sidebar.views.election-switcher :as election-switcher]
   [ballot-scout-v2-frontend.layout.sidebar.views.jurisdiction-switcher :as jurisdiction-switcher]
   [ballot-scout-v2-frontend.layout.sidebar.views.partner-switcher :as partner-switcher]
   [ballot-scout-v2-frontend.subs :as subs]
   [re-frame.core :as rf]))

(defn- heading [{:keys [jurisdiction-slug partner-slug election-slug]}]
  (let [home-link (if @(rf/subscribe [::subs/on-partner-admin-page?])
                    (href :ballot-scout-v2-frontend.routes/partner-home
                          {:partner-slug partner-slug
                           :election-slug election-slug})
                    (href :ballot-scout-v2-frontend.routes/jurisdiction-home
                          {:partner-slug partner-slug
                           :jurisdiction-slug jurisdiction-slug
                           :election-slug election-slug}))
        view-mobile-menu @(rf/subscribe [::subs/view-mobile-menu])]
    [:div.navbar-brand
     [:a.navbar-item {:href home-link}]
     [:div
      {:class "is-size-4 is-clickable is-hidden-tablet ml-5"
       :on-click #(rf/dispatch [::events/set-view-mobile-menu (not view-mobile-menu)])}
      (if view-mobile-menu
        [icon ::icon/times]
        [icon ::icon/bars])]]))

(defn- super-admin-menu []
  [:div.navbar-menu.is-hidden-mobile
   [:div.navbar-start "Super Admin View"]])

(defn- menu []
  [:div.navbar-menu.is-hidden-mobile
   [:div.navbar-start
    [jurisdiction-switcher/component]
    (when (some? @(rf/subscribe [::subs/current-election]))
      [election-switcher/component])
    (when @(rf/subscribe [::subs/admin?])
      [partner-switcher/component])]])

(defn logout-button []
  [:div.navbar-end
   [:div.navbar-item
    [:div.buttons
     [:div.button.is-primary
      [link
       :ballot-scout-v2-frontend.routes/logout
       "Log Out"]]]]])

(defn header []
  (let [current-jurisdiction-slug @(rf/subscribe [::subs/current-jurisdiction-slug])
        current-election-slug @(rf/subscribe [::subs/election-slug-for-sidebar])
        current-partner-slug @(rf/subscribe [::subs/current-partner-slug])
        show-banner? @(rf/subscribe [::subs/show-banner?])]
    [:nav {:class ["navbar" "level" "has-background-grey-darker" "is-paddingless" "is-marginless" (if show-banner? "top-2" "top-0")]
           :role "navigation"
           :aria-label "main navigation"}
     [heading {:jurisdiction-slug current-jurisdiction-slug
               :election-slug current-election-slug
               :partner-slug current-partner-slug}]
     (if @(rf/subscribe [::subs/on-global-stats-page?])
       [super-admin-menu]
       [menu])
     [logout-button]]))
